import { Radio } from '@mantine/core';
import classNames from 'theme/components/Inputs/Radio/Radio.module.css';

export default Radio.extend({
  classNames,
});
